import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { activePromo } from "../../data/promotions";
import { bookUrl } from "../../data/siteConfig";
import { Reveal } from "../Reveal";

export const PromoSection = () => {
  if (!activePromo) return null;
  return (
    <section className="px-5 py-16 md:py-24" data-testid="promo-section">
      <Reveal className="mx-auto grid max-w-6xl overflow-hidden rounded-3xl border border-white/10 bg-coal md:grid-cols-2">
        <div className="relative min-h-[360px] md:min-h-[500px]">
          <img src={activePromo.image} alt={`${activePromo.title} promotional style`} className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent" />
          <p className="absolute bottom-5 left-5 text-[10px] uppercase tracking-[0.28em] text-white/80">summer braid special</p>
        </div>
        <div className="flex flex-col justify-center p-8 md:p-14">
          <p className="font-script text-3xl text-hotpink">{activePromo.kicker}</p>
          <h2 className="mt-3 font-serif text-5xl leading-none md:text-7xl">Feed-In<br /><span className="italic text-hotpink">Braids</span></h2>
          <div className="mt-7 flex items-end gap-3"><span className="font-serif text-4xl">{activePromo.price}</span><span className="pb-1 text-xs uppercase tracking-[0.12em] text-white/45">{activePromo.priceNote}</span></div>
          <ul className="mt-5 grid grid-cols-2 gap-3 text-sm text-white/70">{activePromo.features.map((feature) => <li key={feature} className="flex items-center gap-2"><Sparkles className="h-3 w-3 text-hotpink" />{feature}</li>)}</ul>
          <Link to={bookUrl(activePromo.serviceId)} className="mt-8 inline-flex w-fit rounded-full bg-hotpink px-7 py-3.5 text-xs font-bold uppercase tracking-[0.22em] text-white transition-colors hover:bg-magenta">{activePromo.cta}</Link>
          <p className="mt-5 text-[10px] leading-relaxed text-white/35">Promotional prototype pricing — subject to owner approval.</p>
        </div>
      </Reveal>
    </section>
  );
};
